export default __webpack_public_path__ + "static/media/hypey-white.ac2b01d4.svg";